export class LittaApiError extends Error {
    constructor(
        message: string,
        readonly status: number,
        readonly code?: string,
        readonly apiMessage?: string,
    ) {
        super(message)
        this.name = 'LittaApiError'
    }
}

export function hasApiErrorCode(error: unknown, code: string): boolean {
    return error instanceof LittaApiError && error.code === code
}

export function isForbiddenError(error: unknown): boolean {
    return error instanceof LittaApiError && error.status === 403
}

export function retryUnlessClientError(
    failureCount: number,
    error: Error,
): boolean {
    if (
        error instanceof LittaApiError &&
        error.status >= 400 &&
        error.status < 500
    ) {
        return false
    }
    return failureCount < 3
}

export function littaApiErrorMessage(
    status: number,
    apiMessage: string,
): string {
    if (status === 401) {
        return 'Session expired — please sign in again'
    }
    if (status === 404) {
        return apiMessage || 'Not found'
    }
    if (status === 403) {
        return apiMessage || 'You do not have permission to perform this action'
    }
    return apiMessage || `Request failed (${status})`
}
